export default __webpack_public_path__ + "c1a172d74968a4b9e72eb694f1da27c2.svg";